'use client';

import { ProgressStepper } from '@hyphengroup/cms-components/components/ProgressStepper';
import { hasPersonalLoanLeadForm } from '$/(cms)/-cms/apply-v3/[[...slugs]]/components/ProductCard/PriorityAttribute';
import { ApplyStaticText } from '$/(cms)/-cms/apply-v3/[[...slugs]]/i18n';
import { useClientContext } from '$/modules/context/client';
import { getClientTranslations } from '$/modules/i18n/client.index';

export function ApplyProgressStepper() {
  const context = useClientContext();
  const staticText = getClientTranslations(ApplyStaticText, context);

  const steps = [
    {
      label: staticText.step1Title,
      title: staticText.step1Label,
    },
    {
      label: staticText.step2Title,
      title: hasPersonalLoanLeadForm(context.brand)
        ? staticText.step2LabelProduct
        : staticText.step2Label,
    },
    {
      label: staticText.step3Title,
      title: staticText.step3Label,
    },
  ];

  return (
    <ProgressStepper
      activeStep={0}
      activeStepClassName="[&>p:first-child]:text-[#005f86]"
      inactiveStepClassName="[&>p:first-child]:text-gray-900"
      labelClassName="text-base leading-5"
      steps={steps}
      titleClassName="text-gray-600 text-xs leading-4 md:text-sm md:leading-5"
      variant="text"
    />
  );
}
